if (!customElements.get('atn-community-gallery')) {
  customElements.define('atn-community-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        this.button?.addEventListener('click', this.handleMore);
        return;
      }
      this.gallery = this.querySelector('.atn-community__gallery');
      this.controls = this.querySelector('.atn-community__rotation-controls');
      this.status = this.querySelector('.atn-community__rotation-status');
      this.button = this.querySelector('[data-more-looks]');
      this.cards = Array.from(this.gallery?.children || []);
      this.pageSize = 3;
      this.page = 0;
      if (!this.button || this.cards.length <= this.pageSize || window.Shopify?.designMode) return;

      if (this.dataset.randomize === 'true') {
        for (let index = this.cards.length - 1; index > 0; index--) {
          const target = Math.floor(Math.random() * (index + 1));
          [this.cards[index], this.cards[target]] = [this.cards[target], this.cards[index]];
        }
      }
      const fragment = document.createDocumentFragment();
      this.cards.forEach(card => fragment.appendChild(card));
      this.gallery.appendChild(fragment);
      this.handleMore = () => {
        this.page = (this.page + 1) % Math.ceil(this.cards.length / this.pageSize);
        this.renderPage();
      };
      this.button.addEventListener('click', this.handleMore);
      this.controls.hidden = false;
      this.initialized = true;
      this.renderPage();
    }

    renderPage() {
      const start = this.page * this.pageSize;
      const end = Math.min(start + this.pageSize, this.cards.length);
      this.cards.forEach((card, index) => {
        card.hidden = index < start || index >= end;
      });
      this.gallery.scrollLeft = 0;
      this.status.textContent = this.status.dataset.countTemplate
        .replace('__start__', start + 1)
        .replace('__end__', end)
        .replace('__total__', this.cards.length);
    }

    disconnectedCallback() {
      this.button?.removeEventListener('click', this.handleMore);
    }
  });
}
